import React, { Component } from 'react';
import classSet from 'react-classset';
const desktopVideoSrc = process.env.REACT_APP_VIDEOS_ROOT + 'derm-sleepsound-desktop.mp4';
const desktopPoster = process.env.REACT_APP_VIDEOS_ROOT + 'derm-sleepsound-desktop.png';
const mobileVideoSrc = process.env.REACT_APP_VIDEOS_ROOT + 'derm-sleepsound-mobile.mp4';
const mobilePoster = process.env.REACT_APP_VIDEOS_ROOT + 'derm-sleepsound-mobile.png';
const imageSrc = process.env.REACT_APP_IMAGES_ROOT + 'fpo-bg-image2.jpg';

class AppBackground extends Component {

  componentDidMount() {
    if (!this.props.showVideo || !this.props.playsInline) {return}
    const self = this;
    this.video.addEventListener('ended', () => {
      self.props.onVideoEnded();
    }, false);
  }

  render() {

    let videoSrc, poster, ratio, width, height;
    const winWidth = document.documentElement.clientWidth;
    const winHeight = this.props.appHeight;

    if (winWidth > 736) {
      videoSrc = desktopVideoSrc;
      poster = desktopPoster;
      ratio = 16/9;
    } else {
      videoSrc = mobileVideoSrc;
      poster = mobilePoster;
      ratio = 1;
    }

    if (this.props.showVideo && this.props.playsInline) {
      width = winWidth;
      height = width / ratio;
      if (height < winHeight) {
        height = winHeight;
        width = winHeight * ratio;
      }
    } else {
      width = '100%';
      height = this.props.appHeight
    }

    const baseClasses = classSet({
      'ssc__app-background': true,
      'ssc__app-background--no-mask': this.props.disableMask
    })

    return (
      <div className={baseClasses} style={{width: width, height: height}}>
        {this.props.showVideo && this.props.playsInline ? (
          <video poster={poster} muted autoPlay playsInline ref={el => this.video = el}>
            <source src={videoSrc} type="video/mp4"/>
          </video>
        ) : (
          <img src={imageSrc} alt="app background" />
        )}
      </div>
    );

  }

}

export default AppBackground;


// WEBPACK FOOTER //
// ./src/components/AppBackground/AppBackground.js